import { useSyncExternalStore } from 'react';
import store from '../redux/store';
import { getAdsterIdentitySnapshot } from '../services/adsterTargeting';

function subscribe(callback) {
  // Login/logout/profile updates already dispatch Redux actions after updating storage.
  const unsubscribe = store.subscribe(callback);
  window.addEventListener('storage', callback);
  window.addEventListener('focus', callback);
  window.addEventListener('adster-profile-updated', callback);
  return () => {
    unsubscribe();
    window.removeEventListener('storage', callback);
    window.removeEventListener('focus', callback);
    window.removeEventListener('adster-profile-updated', callback);
  };
}

export default function useAdsterIdentity() {
  return useSyncExternalStore(subscribe, getAdsterIdentitySnapshot, () => 'null');
}
